export const Checkmark = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C7.286 22 4.929 22 3.464 20.535C2 19.071 2 16.714 2 12C2 7.286 2 4.929 3.464 3.464C4.929 2 7.286 2 12 2C16.714 2 19.071 2 20.535 3.464C22 4.929 22 7.286 22 12C22 16.714 22 19.071 20.535 20.535C19.071 22 16.714 22 12 22Z"
      />
      <path
        id="checkmark"
        fillRule="evenodd"
        clipRule="evenodd"
        fill='white'
        d="M16.03 8.97C16.323 9.263 16.323 9.738 16.03 10.031L11.03 15.031C10.737 15.324 10.262 15.324 9.97 15.031L7.97 13.031C7.677 12.738 7.677 12.263 7.97 11.97C8.263 11.677 8.738 11.677 9.03 11.97L10.5 13.439L14.97 8.97C15.263 8.677 15.738 8.677 16.03 8.97Z"
      />
    </svg>
  );
};
